import { render, staticRenderFns } from "./IbxActionBar.vue?vue&type=template&id=592cd18f"
import script from "./IbxActionBar.vue?vue&type=script&lang=js"
export * from "./IbxActionBar.vue?vue&type=script&lang=js"
import style0 from "./IbxActionBar.vue?vue&type=style&index=0&id=592cd18f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports